import {FilterOperator} from '@progress/kendo-data-query';

export const OperatorsByTypeMapping = {
  text: [
    FilterOperator.EqualTo,
    FilterOperator.NotEqualTo,
    FilterOperator.Contains,
    FilterOperator.DoesNotContain,
    FilterOperator.StartsWith
  ],
  predefined: [FilterOperator.EqualTo, FilterOperator.NotEqualTo],
  predefinedList: [FilterOperator.EqualTo, FilterOperator.NotEqualTo],
  user: [FilterOperator.EqualTo, FilterOperator.NotEqualTo],
  numeric: [
    FilterOperator.EqualTo,
    FilterOperator.NotEqualTo,
    FilterOperator.GreaterThanOrEqual,
    FilterOperator.GreaterThan,
    FilterOperator.LessThanOrEqual,
    FilterOperator.LessThan
  ],
  query: [FilterOperator.EqualTo, FilterOperator.NotEqualTo],
  tags: [FilterOperator.EqualTo, FilterOperator.NotEqualTo],
  date: [FilterOperator.GreaterThan, FilterOperator.LessThan]
};
